import { FC } from 'react';

interface AvatarProps {
    name: string;
    show?: boolean;
}

const getAvatarLetters = (name: string): string => {
    const words = name.split(' ');

    if (words.length === 1) {
        return name.slice(0, 2).toUpperCase();
    }

    return (words[0][0] + words[1][0]).toUpperCase();
};

const Avatar: FC<AvatarProps> = ({ name, show }) => {
    if (!show) return null;

    const letters = getAvatarLetters(name);

    return (
        <div className="w-8 h-8 rounded-full flex items-center justify-center text-white text-xs bg-sf-gray-400">
            {letters}
        </div>
    );
};

export default Avatar;
